import React from "react";
import {HashLink as Link} from 'react-router-hash-link';
import Panel from "../../Panel";
import Modal from "../../Modal";

const Ogen = () => (
    <Modal>
        <div>
            <Panel title={'Signalenlijst 12-18 jaar'} link={'Lijst tonen'}
                   intro={'Deze lijst geeft een overzicht van signalen van kindermishandeling bij kinderen in de\n' +
                       '                leeftijd van 12 - 18 jaar. De signalenlijst is een hulpmiddel om een vermoeden van\n' +
                       '                kindermishandeling te onderbouwen, niet om kindermishandeling te ‘bewijzen’.\n' +
                       '                Vrijwel alle genoemde signalen kunnen namelijk een andere oorzaak hebben. Hoe\n' +
                       '                meer van de genoemde signalen het kind uitzendt, hoe groter de kans dat er sprake\n' +
                       '                is van kindermishandeling. Maar er zijn ook kinderen waaraan niet of nauwelijks valt\n' +
                       '                op te merken dat ze worden mishandeld'}
                   open={true}>
                <p className={'text'}>
                    Deze lijst geeft een overzicht van signalen van kindermishandeling bij kinderen in de
                    leeftijd van 12 - 18 jaar. De signalenlijst is een hulpmiddel om een vermoeden van
                    kindermishandeling te onderbouwen, niet om kindermishandeling te ‘bewijzen’.
                    Vrijwel alle genoemde signalen kunnen namelijk een andere oorzaak hebben. Hoe
                    meer van de genoemde signalen het kind uitzendt, hoe groter de kans dat er sprake
                    is van kindermishandeling. Maar er zijn ook kinderen waaraan niet of nauwelijks valt
                    op te merken dat ze worden mishandeld
                </p>

                <a className={'download'} href={'https://care-free.app/wp-content/uploads/2022/05/Care-Free-Signalenlijst-12-18.pdf'} target={'_blank'}>Download als PDF bestand</a>

                <h3>Lichamelijk welzijn</h3>

                <ul>
                    <li>blauwe plekken, brandwonden, botbreuken, snij-, krab- en bijtwonden</li>
                    <li>te dik</li>
                    <li>slecht onderhouden gebit</li>
                    <li>regelmatig buikpijn, hoofdpijn of flauwvallen</li>
                    <li>kind stinkt, heeft regelmatig smerige kleren aan</li>
                    <li>oververmoeid</li>
                    <li>vaak ziek</li>
                    <li>ziektes herstellen slecht</li>
                    <li>kind is hongerig</li>
                    <li>eetstoornissen</li>
                    <li>achterblijvende motoriek</li>
                </ul>

                <h3>Gedrag van het kind</h3>

                <ul>
                    <li>timide, depressief</li>
                    <li>weinig spontaan</li>
                    <li>passief, lusteloos, weinig interesse in spel</li>
                    <li>apathisch, toont geen gevoelens of pijn</li>
                    <li>in zichzelf gekeerd, leeft in fantasiewereld</li>
                    <li>labiel</li>
                    <li>erg nerveus</li>
                    <li>hyperactief</li>
                    <li>negatief zelfbeeld, weinig zelfvertrouwen, faalangst</li>
                    <li>negatief lichaamsbeeld</li>
                    <li>agressief, vernielzucht</li>
                    <li>overmatige masturbatie</li>
                </ul>

                <h3>Tegenover andere kinderen</h3>

                <ul>
                    <li>agressief</li>
                    <li>speelt weinig met andere kinderen</li>
                    <li>vluchtige vriendschappen (12-18)</li>
                    <li>wantrouwend</li>
                    <li>niet geliefd bij andere kinderen</li>
                </ul>

                <h3>Tegenover ouders</h3>

                <ul>
                    <li>angstig, schrikachtig, waakzaam</li>
                    <li>meegaand, volgzaam</li>
                    <li>gedraagt zich in bijzijn van ouders anders dan zonder ouders</li>
                    <li>agressief</li>
                </ul>

                <h3>Tegenover andere volwassenen</h3>

                <ul>
                    <li>angst om zich uit te kleden</li>
                    <li>angst voor lichamelijk onderzoek</li>
                    <li>verstijft bij lichamelijk contact</li>
                    <li>angstig, schrikachtig, waakzaam</li>
                    <li>meegaand, volgzaam</li>
                    <li>agressief</li>
                    <li>overdreven aanhankelijk</li>
                    <li>wantrouwend</li>
                    <li>vermijdt oogcontact</li>
                </ul>

                <h3>Overig</h3>

                <ul>
                    <li>plotselinge gedragsverandering</li>
                    <li>gedraagt zich niet naar zijn leeftijd</li>
                    <li>slechte leerprestaties</li>
                    <li>rondhangen na school</li>
                    <li>taal- en spraakstoornissen</li>
                    <li>alcohol- of drugsmisbruik</li>
                    <li>weglopen</li>
                    <li>crimineel gedrag</li>
                </ul>

                <h3>Gedrag van de ouder</h3>

                <ul>
                    <li>onverschillig over het welzijn van het kind</li>
                    <li>laat zich regelmatig negatief uit over het kind</li>
                    <li>troost het kind niet</li>
                    <li>geeft aan het niet meer aan te kunnen</li>
                    <li>is verslaafd</li>
                    <li>is ernstig (psychisch) ziek</li>
                    <li>kleedt het kind te warm of te koud aan</li>
                    <li>zegt regelmatig afspraken af</li>
                    <li>houdt het kind vaak thuis van school</li>
                    <li>heeft irreële verwachtingen van het kind</li>
                    <li>zet het kind onder druk om te presteren</li>
                </ul>

                <h3>Gezinssituatie</h3>

                <ul>
                    <li>samengaan van stressvolle omstandigheden, zoals slechte huisvesting, financiële problemen en
                        relatieproblemen
                    </li>
                    <li>sociaal isolement</li>
                    <li>alleenstaande ouder</li>
                    <li>partnermishandeling</li>
                    <li>gezin verhuist regelmatig</li>
                    <li>slechte algehele hygiëne</li>
                </ul>

                <h2>Signalen specifiek voor seksueel misbruik</h2>

                <h3>Lichamelijk welzijn</h3>

                <ul>
                    <li>verwondingen aan geslachtsorganen</li>
                    <li>vaginale infecties en afscheiding</li>
                    <li>jeuk bij vagina of anus</li>
                    <li>pijn in bovenbenen</li>
                    <li>pijn bij lopen of zitten</li>
                    <li>problemen bij plassen</li>
                    <li>urineweginfecties</li>
                    <li>seksueel overdraagbare aandoeningen</li>
                    <li>(angst voor) zwangerschap</li>
                </ul>

                <h3>Gedrag van het kind</h3>

                <ul>
                    <li>drukt benen tegen elkaar bij het lopen</li>
                    <li>afkeer lichamelijk contact</li>
                    <li>maakt afwezige indruk bij lichamelijk onderzoek</li>
                    <li>extreem seksueel gekleurd gedrag en taalgebruik</li>
                    <li>veel wisselende seksuele contacten met leeftijdsgenoten</li>
                    <li>zoekt seksuele toenadering tot volwassenen</li>
                    <li>prostitutie</li>
                </ul>

                <p className={'qoute-source'}>
                    <strong>Bron</strong>: Deze signalenlijst is overgenomen uit de publicatie van het Nederlands
                    Jeugdinstituut: Wolzak, A. (2012, 7e druk). Kindermishandeling: signaleren en
                    handelen. Te bestellen via <a href={'https://www.nji.nl/nl/Kennis/Publicaties'}
                                                  target={'_blank'}>www.nji.nl/nl/Kennis/Publicaties</a>
                </p>
            </Panel>
        </div>
    </Modal>
);


export default Ogen;
